import * as React from 'react';
import { PropsWithChildren, ReactNode } from 'react';
import { Hierarchy, HierarchyApi } from '../../api/core';
import { HierarchyToolTip } from './HierarchyToolTip';

interface Props {
  idx: string;
  id: string;
}

export const OrganisationHierarchyToolTip: React.FC<PropsWithChildren<Props>> = (props: PropsWithChildren<Props>): ReactNode => {
  const [hierarchy, setHierarchy] = React.useState<Hierarchy[]>(null);

  const load = async (): Promise<void> => {
    if (hierarchy) return;
    try {
      const api: HierarchyApi = new HierarchyApi();
      const result: Hierarchy[] = await api.getOrganisationHierarchy({organisationId: parseInt(props.id, 10)});
      setHierarchy(result || []);
    } catch (error) {
      setHierarchy([]);
    }
  };

  return (<HierarchyToolTip idx={props.idx} hierarchy={hierarchy} onBeforeShow={load} children={props.children}
                            path={'organisation'}/>);
};
